export class TopNavBtn {
  title: string;
  imageName: string;
  href: string;
  isRouterlink: boolean;
  isAdminRestricted: boolean;
  hideFromRestrictedUser: boolean;
  needsDataWallSub: boolean;
  openInNewTab: boolean;
  dropdownItems: Array<TopNavDropdownItem>;
  otherReportsUrl: string;
  ninthGradeSuccessUrl: string;
  dataId?: string;
  constructor(
    title: string,
    imageName: string,
    href: string,
    isRouterlink: boolean,
    isAdminRestricted: boolean,
    hideFromRestrictedUser: boolean,
    needsDataWallSub: boolean,
    openInNewTab: boolean,
    dropdownItems: Array<TopNavDropdownItem>,
    otherReportsUrl: string,
    ninthGradeSuccessUrl: string,
    dataId?: string
  ) {
    this.title = title;
    this.imageName = imageName;
    this.href = href;
    this.isRouterlink = isRouterlink;
    this.isAdminRestricted = isAdminRestricted;
    this.hideFromRestrictedUser = hideFromRestrictedUser;
    this.needsDataWallSub = needsDataWallSub;
    this.openInNewTab = openInNewTab;
    this.dropdownItems = dropdownItems;
    this.otherReportsUrl = otherReportsUrl;
    this.ninthGradeSuccessUrl = ninthGradeSuccessUrl;
    this.dataId = dataId;
  }
}

export class TopNavDropdownItem {
  title: string;
  href: string;
  isRouterlink: boolean;
  isAdminRestricted: boolean;
  hideFromRestrictedUser: boolean;
  needsDataWallSub: boolean;
  openInNewTab?: boolean;
  otherReportsUrl: string;
  ninthGradeSuccessUrl: string;
  dataId?: string;

  constructor(
    title: string,
    href: string,
    isRouterlink: boolean,
    isAdminRestricted: boolean,
    hideFromRestrictedUser: boolean,
    needsDataWallSub: boolean,
    otherReportsUrl: string,
    ninthGradeSuccessUrl: string,
    openInNewTab?: boolean,
    dataId?: string
  ) {
    this.title = title;
    this.href = href;
    this.isRouterlink = isRouterlink;
    this.isAdminRestricted = isAdminRestricted;
    this.hideFromRestrictedUser = hideFromRestrictedUser;
    this.needsDataWallSub = needsDataWallSub;
    this.openInNewTab = openInNewTab;
    this.otherReportsUrl = otherReportsUrl;
    this.ninthGradeSuccessUrl = ninthGradeSuccessUrl;
    this.dataId = dataId;
  }
}
